<template>
    <b-form class="row" :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" :initial-data="initialData">

        <div class="col-6">
            <validated-input disabled label="Username" placeholder="Username" class="c-form-input"
                             v-model="model.username" :rules="{required:true}" @blur="checkUsername"/>
        </div>

        <div class="col-6">
            <validated-input label="Employee ID" placeholder="Example: ENP576281" class="c-form-input"
                             v-model="model.employee_number" :rules="{required:true}"/>
        </div>

        <div class="col-6">
            <validated-input label="First Name" placeholder="First Name" class="c-form-input"
                             v-model="model.first_name" :rules="{required:true}"/>
        </div>

        <div class="col-6">
            <validated-input label="Last Name" placeholder="Last Name" class="c-form-input"
                             v-model="model.last_name" :rules="{required:true}"/>
        </div>

        <div class="col-6">
            <validated-input label="Mobile Number*" placeholder="Mobile number" class="c-form-input"
                             v-model="model.mobile_number" type="number" name="Mobile number"
                             :rules="{required:true, min:10, max:10}" @blur="checkMobile(model.mobile_number)"/>
        </div>

        <div class="col-6">
            <validated-input label="E-Mail ID*" placeholder="E-Mail ID" type="email"
                             class="c-form-input" name="E-Mail ID" @input="customEmailValidate(model.email)"
                             v-model="model.email" @blur="checkEmailExists(model.email)"
                             :rules="{required:rules.email}"/>
            <p class="text-danger" v-if="invalidEmail && model.email">Entered domain address is not accepted.</p>
        </div>

        <div class="col-12">
            <validated-input label="Designation" placeholder="Example: Database Manager" class="c-form-input"
                             name="Employee role"
                             v-model="model.employee_role" :rules="{required:true}"/>
        </div>

        <div class="col-12">
            <div class="fl-x fl-j-c">
                <btn text="Update" loading-text="Updating..." :loading="loading" class="px-5 ml-3" design="basic-a"
                     color="secondary"></btn>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '../../data/urls';
import axios from 'secure-axios';

export default {
    name : 'EditUser',

    props : { initialData : { type : Object } },

    data () {
        return {
            loading      : false,
            invalidEmail : false,
            rules        : {
                email : {
                    required : true
                }
            },
            addUrl : urls.userList.addEdit,

            userId : ''
        };
    },

    methods : {
        formSuccess () {
            this.$notify('Successfully Updated the user..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        },

        checkUsername (username) {
            const that = this;
            const data = {
                username : username
            };

            axios.form(urls.userList.usernameCheck, data).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                } else {
                    that.$refs.formValidator.setErrors({ Username : json.message });
                }
            }).catch(function (exception) {
                console.log('exception occurred during the checking for username availability : ', exception);
            });
        },

        customEmailValidate (value) {
            const allowedDomains = ['yahoo.com', 'gmail.com', 'outlook.com', 'hotmail.com'];
            const domain = value.split('@')[1];
            this.invalidEmail = allowedDomains.includes(domain);
        },

        checkEmailExists (email) {
            const that = this;
            const data = {
                email : email
            };
            axios.form(urls.userList.emailCheck, data).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                } else {
                    if (!that.invalidEmail) {
                        that.$refs.formValidator.setErrors({ email : json.message });
                    }
                }
            }).catch(function (exception) {
                console.log('exception occurred during the checking for username availability : ', exception);
            });
        },

        checkMobile (mobile) {
            const that = this;
            const data = {
                mobile : mobile
            };

            axios.form(urls.userList.mobileCheck, data).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                } else {
                    that.$refs.formValidator.setErrors({ 'Mobile number' : json.message });
                }
            }).catch(function (exception) {
                console.log('exception occurred during the checking for username availability : ', exception);
            });
        }
    }
};
</script>

<style scoped>

</style>
